import { lazy } from 'react'

const Announcements = lazy(() => import('../../views/announcements'))
const Messages = lazy(() => import('../../views/messages'))
const Reminders = lazy(() => import('../../views/reminders'))

const AnnouncementRoutes = [
  {
    element: <Announcements key="notice" />,
    path: '/announcements',
    meta: { action: 'read', resource: 'Announcement' }
  },
  {
    element: <Announcements key="news" />,
    path: '/news',
    meta: { action: 'read', resource: 'News' }
  },
  {
    element: <Messages />,
    path: '/messages',
    meta: { action: 'read', resource: 'Message' }
  },
  {
    element: <Reminders />,
    path: '/reminders',
    meta: { action: 'read', resource: 'Reminder' }
  }
]

export default AnnouncementRoutes
